<template>
    <div>
        <div class="bar" id="barId"></div>
        <div class="tip">2026年第一季度全国一张图切片影像套件现已上线！</div>
        <div class="white" id="whiteId">
            <!-- 模块一 -->
            <div class="noBuy" v-if="block1Status==1">
                <div class="baseText1">选择您的影像套件</div>
                <img src="~@/assets/newHome/查看价格.png" alt="" class="baseImg1">
                <div class="baseText2">想详细了解各版本的细则和权益？</div>
                <div class="baseText3" style="cursor: pointer;" @click="$router.push('/Price');">点击查看 ></div>
            </div>
            <div class="buyBasis" v-if="block1Status==2">
                <div class="baseText1">您已获得吉林一号切片影像套件体验版使用权</div>
                <div class="baseText3" style="top: 72px;cursor: pointer;"  @click="$router.push('/MyRSservice');">查看我的套件 ></div>
                <!-- <div class="baseText1" style="top: 194px;">体验版不够用？请购买标准版</div> -->
                <img src="~@/assets/newHome/查看价格.png" alt="" class="baseImg1" style="top: 180px;">
                <div class="baseText2" style="top: 220px;">想详细了解各版本的细则和权益？</div>
                <div class="baseText3" style="top: 250px;cursor: pointer;" @click="$router.push('/Price');">点击查看 ></div>
            </div>
            <!-- <div class="buyEnterprise" v-if="block1Status==3">
                <div class="baseText1">您的账户中有尚在有效期内的标准版套件</div>
                <div class="baseText3" style="top: 72px;cursor: pointer;"  @click="$router.push('/MyRSservice');">查看我的套件 ></div>
                <div class="baseText1" style="top: 194px;">调用面积或次数不够用？请增购标准版</div>
                <img src="~@/assets/newHome/查看价格.png" alt="" class="baseImg1" style="top: 286px;">
                <div class="baseText2" style="top: 330px;">想详细了解各版本的细则和权益？</div>
                <div class="baseText3" style="top: 364px;cursor: pointer;" @click="$router.push('/Price');">点击查看 ></div>
            </div> -->
            <!-- 模块二 -->
            <div class="block2">
                <div class="selectBlock2" v-if="selectBasis==0" @click="selectVersion(1)" style="left:calc(50% - 650px) ;">
                    <div class="selectText1">体验版</div>
                    <div class="selectText2">适用于个人用户</div>
                </div>
                <div class="selectBlock2" v-if="selectBasis==1" style="border: 2px solid #1E81EB;left:calc(50% - 650px)">
                    <div class="selectText1">体验版</div>
                    <div class="selectText2">适用于个人用户</div>
                </div>
                <div class="selectBlock2" v-if="selectBasis==2" style="background: #F2F2F2;left:calc(50% - 650px)">
                    <div class="selectText1" style="color: #979797;">体验版</div>
                    <div class="selectText2" style="color: #979797;">适用于个人用户</div>
                </div>
                <div class="selectBlock2" style="left: 440px;" v-if="selectEnterprise==0" @click="selectVersion(2)">
                    <div class="selectText1">标准版</div>
                    <div class="selectText2">适用于对调用次数有较大需求的用户</div>
                </div>
                <div class="selectBlock2" style="left: 440px;border: 2px solid #1E81EB;" v-if="selectEnterprise==1">
                    <div class="selectText1">标准版</div>
                    <div class="selectText2">适用于对调用次数有较大需求的用户</div>
                </div>
                <div class="selectBlock2" style="left:calc(50% + 250px);" v-if="selectBusiness==0" @click="selectVersion(3)" >
                    <div class="selectText1">专业版</div>
                    <div class="selectText2">适用于按需购买的政企、个人用户</div>
                </div>
                <div class="selectBlock2" style="left: calc(50% + 250px);border: 2px solid #1E81EB;" v-if="selectBusiness==1">
                    <div class="selectText1">专业版</div>
                    <div class="selectText2">适用于按需购买的政企、个人用户</div>
                </div>
            </div>
            <!-- 模块三 -->
            <div class="block3Basis" v-if="baseInfo==0" style="height: 100px;"></div>
            <div class="block3Basis" v-if="baseInfo==1">
                <img src="~@/assets/newHome/Step1.png" alt="" class="block3Img">
                <div class="block3Text1">完善您的个人资料</div>
                <div class="block3Line"></div>
                <div class="infoRed" v-if="infoIsRed1==1">您尚未完善个人资料</div>

                <v-text-field
                    class="block3Name"
                    v-model="nameUser"
                    placeholder=""
                    label="姓名 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-text-field>
                <v-select
                    v-model="sexUser"
                    class="block3Name"
                    style="left: 400px;width: 200px;"
                    :items="sexList"
                    label="性别"
                    placeholder=" "
                    outlined
                    :rules="[rules.notNull]"
                ></v-select>
                <v-text-field
                    class="block3Name"
                    style="left: 610px;width: 670px;"
                    v-model="ageUser"
                    placeholder=""
                    label="年龄 *"
                    outlined
                    :rules="[rules.ageJudge]"
                ></v-text-field>
                <v-select
                    class="block3Name"
                    style="width: 600px;top: 257px;"
                    v-model="educationUser"
                    placeholder=""
                    :items="educationList"
                    label="学历 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-select>
                <v-text-field
                    class="block3Name"
                    style="width: 670px;top: 257px;left: 610px;"
                    v-model="companyUser"
                    placeholder=""
                    label="单位/机构 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-text-field>
                <img src="~@/assets/newHome/不同意协议.png" alt="" class="block3Img1" v-if="!xieyi" @click="xieyi=true">
                <img src="~@/assets/newHome/同意协议.png" alt="" class="block3Img1" v-if="xieyi" @click="xieyi=false">
                <div class="block3Text2" style="top: 380px;left: 30px;font-weight: 400;font-size: 14px;">您已同意 <span style=" font-weight: 600;color: #1E81EB;cursor: pointer;" @click="openXieyi()">《“吉林一号”遥感影像套件用户使用协议》</span></div>
                <div class="block3Line" style="width: 1280px;left: 0;top: 416px;"></div>
                <div class="infoRed" style="top: 396px;" v-if="infoIsRed3==1">您尚未同意《“吉林一号”遥感影像套件用户使用协议》</div>
                <div class="block3Text2">体验版</div>
                <div class="block3Text2" style="top: 469px;">限时免费</div>
                <div class="block3Button1" @click="applyBasis()">申请使用</div>
            </div>
            <!--标准版套件-->
            <div class="block3Basis" v-if="baseInfo==2" style="height: auto;">
                <div class="block3BasisContent" style="height: 820px">
                    <img src="~@/assets/newHome/Step1.png" alt="" class="block3Img">
                    <div class="block3Text1">完善您的个人资料</div>
                    <div class="block3Line"></div>
                    <div class="infoRed" v-if="infoIsRed1==1">您尚未完善个人资料</div>
                    <v-text-field
                        class="block3Name"
                        style="top: 146px;"
                        v-model="nameUser"
                        placeholder=""
                        label="姓名 *"
                        outlined
                        :rules="[rules.notNull]"
                    ></v-text-field>
                    <v-select
                        v-model="sexUser"
                        class="block3Name"
                        style="left: 400px;width: 200px;top: 146px;"
                        :items="sexList"
                        label="性别"
                        placeholder=" "
                        outlined
                        :rules="[rules.notNull]"
                    ></v-select>
                    <v-text-field
                        class="block3Name"
                        style="left: 610px;width: 670px;top: 146px;"
                        v-model="ageUser"
                        placeholder=""
                        label="年龄 *"
                        outlined
                        :rules="[rules.ageJudge]"
                    ></v-text-field>
                    <v-select
                        class="block3Name"
                        style="width: 600px;top: 232px;"
                        v-model="educationUser"
                        placeholder=""
                        :items="educationList"
                        label="学历 *"
                        outlined
                        :rules="[rules.notNull]"
                    ></v-select>
                    <v-text-field
                        class="block3Name"
                        style="width: 670px;top: 232px;left: 610px;"
                        v-model="companyUser"
                        placeholder=""
                        label="单位/机构 *"
                        outlined
                        :rules="[rules.notNull]"
                    ></v-text-field>
                    <img src="~@/assets/newHome/Step2.png" alt="" class="block3Img" style="top: 371px;width: 186px;">
                    <div class="block3Text1" style="top: 413px;">选择产品类型</div>
                    <div class="block3Line" style="top: 395px;"></div>
                    <div class="checkBlockCtn" style="top:500px">
                      <a-radio-group name="radioGroup" v-model="standardParam.productType">
                        <a-radio value="A" style="margin-right: 60px;">标准版A（调用次数50万次/日）</a-radio>
                        <a-radio value="B">标准版B（调用次数300万次/日）</a-radio>
                      </a-radio-group>
                    </div>
                    <div>
                      <img src="~@/assets/newHome/Step3.png" alt="" class="block3Img" style="top: 620px;width: 186px;">
                      <div class="block3Text1" style="top:663px;">选择购买切片</div>
                      <div class="block3Line" style="top: 660px;"></div>
                      <div class="checkBlockCtn" style="top:760px">
                        <a-radio-group name="radioGroup2" v-model="standardParam.yearVersion">
                          <a-radio value="2024年全国高质量一张图" style="margin-right: 60px;">2024年全国高质量一张图（0.5m分辨率）</a-radio>
                          <a-radio value="2023年全国高质量一张图" style="margin-right: 60px;">2023年全国高质量一张图（0.5m分辨率）</a-radio>
                          <a-radio value="2022年全国高质量一张图">2022年全国高质量一张图（0.75m分辨率）</a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                </div>
                <div class="block3Tex6">
                    <img src="~@/assets/newHome/不同意协议.png" alt="" class="block3Img1" v-if="!xieyi" @click="xieyi=true;infoIsRed3=false" style="top: 4px;">
                    <img src="~@/assets/newHome/同意协议.png" alt="" class="block3Img1" v-if="xieyi" @click="xieyi=false" style="top: 4px;">
                    <div class="block3Text5">您已同意 <span style=" font-weight: 600;color: #1E81EB;cursor: pointer;" @click="openXieyi()">《“吉林一号”遥感影像套件用户使用协议》</span></div>
                </div>
              <div class="infoRed" style="top: 910px;" v-if="infoIsRed3==1">您尚未同意《“吉林一号”遥感影像套件用户使用协议》</div>
                <div class="blockLine3-s"></div>
                <div style="position: relative;margin-top: 0px;width: 1280px;height: 284px;">
                    <div class="standardPriceCtn">
                      订单金额：<span style="color: red;font-size: 18px;">￥  {{ standardPrice }}</span>
                    </div>
                    <div class="block3Button" style="top: 30px;" @click="applyEnterprise()">立即购买</div>
                </div>


            </div>
            <div class="block3Basis" v-if="baseInfo==3">
                <img src="~@/assets/newHome/Step1.png" alt="" class="block3Img">
                <div class="block3Text1">完善您的个人资料</div>
                <div class="block3Line"></div>
                <div class="infoRed" v-if="infoIsRed1==1">您尚未完善个人资料</div>

                <v-text-field
                    class="block3Name"
                    v-model="nameUser"
                    placeholder=""
                    label="姓名 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-text-field>
                <v-select
                    v-model="sexUser"
                    class="block3Name"
                    style="left: 400px;width: 200px;"
                    :items="sexList"
                    label="性别"
                    placeholder=" "
                    outlined
                    :rules="[rules.notNull]"
                ></v-select>
                <v-text-field
                    class="block3Name"
                    style="left: 610px;width: 670px;"
                    v-model="ageUser"
                    placeholder=""
                    label="年龄 *"
                    outlined
                    :rules="[rules.ageJudge]"
                ></v-text-field>
                <v-select
                    class="block3Name"
                    style="width: 600px;top: 257px;"
                    v-model="educationUser"
                    placeholder=""
                    :items="educationList"
                    label="学历 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-select>
                <v-text-field
                    class="block3Name"
                    style="width: 670px;top: 257px;left: 610px;"
                    v-model="companyUser"
                    placeholder=""
                    label="单位/机构 *"
                    outlined
                    :rules="[rules.notNull]"
                ></v-text-field>
                <!-- <img src="~@/assets/newHome/不同意协议.png" alt="" class="block3Img1" v-if="!xieyi" @click="xieyi=true">
                <img src="~@/assets/newHome/同意协议.png" alt="" class="block3Img1" v-if="xieyi" @click="xieyi=false">
                <div class="block3Text2" style="top: 380px;left: 30px;font-weight: 400;font-size: 14px;">您已同意 <span style=" font-weight: 600;color: #1E81EB;cursor: pointer;" @click="openXieyi()">《“吉林一号”遥感影像套件用户使用协议》</span></div> -->
                <div class="block3Line" style="width: 1280px;left: 0;top: 416px;"></div>
                <!-- <div class="infoRed" style="top: 396px;" v-if="infoIsRed3==1">您尚未同意《“吉林一号”遥感影像套件用户使用协议》</div> -->
                <div class="block3Text2">根据实际选择区域范围定价</div>
                <!-- <div class="block3Text2" style="top: 469px;">限时免费</div> -->
                <div class="block3Button1" @click="applyCouty()">去选定区域</div>
                <!-- <div class="block3Text4">购买图商版请联系商务经理：0431-86008580</div> -->
            </div>
        </div>
        <!-- 认证身份弹窗 -->
        <div class="shadow" v-if="shadowTip">
            <div class="shadowWhite">
                <img src="../assets/newHome/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
                <div class="shadowText1">用户身份认证</div>
                <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/ApplyGovernmentMember','/rskit')">
                    <img src="../assets/buyCountyProduction/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/OpenEducationalCertification','/rskit')" style="left: 400px;">
                    <img src="../assets/buyCountyProduction/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
            </div>
        </div>
        <!-- 机构企业：授权委托书（顶栏提示叠在蒙层上方，不依赖 $message 的 z-index） -->
        <div v-if="authLetterModalVisible" class="authLetterLayer">
        <div class="authLetterShadow" @click.self="closeAuthLetterModal">
            <div class="authLetterModal" @click.stop>
                <img src="../assets/newHome/日历关闭.png" alt="" class="authLetterClose" @click="closeAuthLetterModal">
                <div class="authLetterTitle">{{ authLetterTitle }}</div>
                <div class="authLetterDesc" v-if="authLetterModalMode!=='rejected'">{{ authLetterBodyText }}</div>
                <template v-else>
                    <div class="authLetterDesc">很抱歉，您的授权委托书未通过审核，请重新上传。</div>
                    <div class="authLetterReject" v-if="authorizationLetterRejectReason">未通过原因：{{ authorizationLetterRejectReason }}</div>
                </template>
                <div
                    class="authLetterDrop"
                    :class="{ 'authLetterDrop--active': authLetterDragOver }"
                    @click="triggerAuthFileInput"
                    @dragover.prevent="onAuthDragOver"
                    @dragleave.prevent="onAuthDragLeave"
                    @drop.prevent="onAuthFileDrop"
                >
                    <input
                        ref="authFileInput"
                        type="file"
                        class="authLetterFileInput"
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                        @change="onAuthFileChange"
                    >
                    <div class="authLetterDropIcon" aria-hidden="true">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#1E81EB" fill-opacity="0.15"/>
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" stroke="#1E81EB" stroke-width="1.2"/>
                            <path d="M12 9v6M9 12h6" stroke="#1E81EB" stroke-width="1.2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <div class="authLetterDropLine1">点击或将文件拖拽到这里上传</div>
                    <div class="authLetterDropLine2">支持扩展名：.pdf .jpg .png .jpeg</div>
                </div>
                <div class="authLetterFileRow" v-if="authLetterPendingName">
                    <span class="authLetterFileClip">&#128206;</span>
                    <span class="authLetterFileName">{{ authLetterPendingName }}</span>
                    <span class="authLetterFileRemove" @click.stop="clearAuthFile">×</span>
                </div>
                <div class="authLetterBar" v-if="authLetterPendingName"></div>
                <a
                    href="javascript:;"
                    class="authLetterLink"
                    :class="{ 'authLetterLink--disabled': authLetterTemplateLoading }"
                    @click.prevent="downloadAuthLetterTemplate"
                >{{ authLetterTemplateLoading ? '正在获取…' : '点击下载授权委托书模版' }}</a>
                <div class="authLetterBtns">
                    <div class="authLetterBtn1" :class="{ 'authLetterBtn1--disabled': authLetterUploading }" @click="confirmAuthLetterAction">{{ authLetterPrimaryLabel }}</div>
                    <div class="authLetterBtn2" v-if="!authLetterUploading" @click="closeAuthLetterModal">暂不上传</div>
                </div>
            </div>
        </div>
            <div v-if="authLetterTopTip" class="authLetterTopTip">
                <div
                    class="authLetterTopTipInner"
                    :class="'authLetterTopTipInner--' + authLetterTopTipType"
                >
                    <span class="authLetterTopTipMark" v-if="authLetterTopTipType === 'success'">✓</span>
                    <span class="authLetterTopTipMark" v-else>×</span>
                    <span class="authLetterTopTipText">{{ authLetterTopTip }}</span>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
  import gsap from "gsap";
  import {rootUrl} from '@/globalConfig'
  //根据传递的参数展示相应页面
  //参数说明
  // block1Status： 1 未申请体验版和标准版  2 申请体验版未申请标准版  3 申请标准版体验版都可以
  // selectBasis 0 体验版未选中  1体验版选中  2 体验版不可选
  // selectEnterprise  0标准版未选中 1标准版选中
  // selectBusiness 0区县图未选中 1区县图选中 //区县就是专业版
  // baseInfo  0不提交信息 1提交体验版信息 2提交标准版信息 3提交区县图信息
  export default {
    name: "Purchase",
    data() {
      return {
        //标准版相关参数
        standardPrice:'',
        standardParam:{
          productType:'A',
          yearVersion:'2024年全国高质量一张图',
        },
        processType:0,
        block1Status:1,
        selectBasis:1,
        selectEnterprise:0,
        selectBusiness:0,
        baseInfo:1,
        //判断当前进入该页面是体验版接口还是标准版接口
        version:1,
        //1-5是23年；6-10是24年
        priceSelect:6,
        nameUser: "",
        sexUser:"",
        sexList:["男","女"],
        ageUser:"",
        educationUser:"",
        educationList:["高中","专科","本科","硕士研究生","博士研究生","博士后"],
        companyUser:"",
        contractUser:"",
        infoIsRed1:0,
        infoIsRed2:0,
        infoIsRed3:0,
        infoIsRed4:0,
        infoIsRed5:0,
        timer:"",
        timer2:"",
        timer3:"",
        invoice:1,
        qyCompany:"",
        qyNumber:"",
        zpCompany:"",
        zpNumber:"",
        address:"",
        phone:"",
        bank:"",
        bankNumber:"",
        xieyi:false,
        purchaseMode:1,
        inputList: [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }], //根据个数
        repInputContent:'',
        rules: {
            notNull: (value) => {
            if (value == "" || value == null) {
                return "此项不能为空";
            } else {
                return true;
            }
            },
            emialNumber: (value) => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value) || "邮箱不合法",
            ageJudge: (value) => {
                if(!isNaN(parseFloat(value)) && isFinite(value)){
                    if(value>=0&&value<=100){
                        return true;
                    }else{
                        return "年龄输入不合法";
                    }
                }else{
                    return "年龄输入不合法";
                }

            },
        },
        ifPurchased:false,
        shadowTip:false,
        // 授权委托书弹窗
        authLetterModalVisible: false,
        authLetterModalMode: "initial",
        enterpriseCertInfoId: null,
        authorizationLetterRejectReason: "",
        authLetterPendingFile: null,
        authLetterPendingName: "",
        authLetterUploading: false,
        authLetterDragOver: false,
        authLetterCompanyName: "",
        authLetterCreditCode: "",
        authLetterTemplateLoading: false,
        authLetterTopTip: "",
        authLetterTopTipType: "success",

      };
    },
    computed: {
        authLetterTitle() {
            if (this.authLetterModalMode === "pending") return "授权委托书审核中";
            return "上传授权委托书";
        },
        authLetterBodyText() {
            if (this.authLetterModalMode === "pending") {
                return "您上传的授权委托书正在审核中，请耐心等待。";
            }
            return "根据平台管理要求，机构企业用户购买遥感商城产品需要签署授权委托书并盖章上传，审核通过后可享受专属购买权益。";
        },
        authLetterPrimaryLabel() {
            return this.authLetterModalMode === "initial" ? "确认上传" : "重新上传";
        },
    },
    methods: {
        // 标准版立即购买主流程：写入订单并跳转
        proceedToStandardOrder() {
            if (this.ageUser === "" || this.companyUser === "" || this.educationUser === "" || this.sexUser === "" || this.nameUser === "") {
                this.infoIsRed1 = 1;
                return;
            }
            this.infoIsRed1 = 0;
            let selectProductId = "";
            if (this.standardParam.yearVersion == "2023年全国高质量一张图") {
                selectProductId = "standard_" + this.standardParam.productType + "_2023";
            } else if (this.standardParam.yearVersion == "2024年全国高质量一张图") {
                selectProductId = "standard_" + this.standardParam.productType + "_2024";
            } else if (this.standardParam.yearVersion == "2022年全国高质量一张图") {
                selectProductId = "standard_" + this.standardParam.productType + "_2022";
            }
            this.$store.state.standardKitOrder = {
                productType: this.standardParam.productType,
                yearVersion: this.standardParam.yearVersion,
                age: this.ageUser,
                company: this.companyUser,
                education: this.educationUser,
                sex: this.sexUser,
                name: this.nameUser,
                baseId: selectProductId,
                standardPrice: this.standardPrice,
            };
            if (this.ifPurchased) {
                alert("您已购买过此版本的标准版套件");
                return;
            }
            this.$router.push("/demandConfirm_standard");
            this.axios
                .post(
                    "/tilesapi/tiles/register/addCompanyTileOrder",
                    {
                        age: this.ageUser,
                        company: this.companyUser,
                        education: this.educationUser,
                        sex: this.sexUser,
                        name: this.nameUser,
                        baseId: selectProductId,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }
                )
                .then((res) => { });
        },
        mapAuthorizationLetterView(statusRaw) {
            if (statusRaw === null || statusRaw === undefined || statusRaw === "") return "initial";
            const t = String(statusRaw).trim();
            if (t === "null" || t === "undefined") return "initial";
            if (t === "未通过" || t.includes("未通过")) return "rejected";
            if (t === "审核中" || t.includes("审核中")) return "pending";
            if (t === "已通过" || t.includes("已通过")) return "proceed";
            if (t === "0" || t === 0) return "initial";
            if (t === "1" || t === 1) return "pending";
            if (t === "2" || t === 2) return "proceed";
            if (t === "3" || t === 3) return "rejected";
            return "initial";
        },
        loadEnterpriseCertInfoForLetterModal() {
            if (this.ageUser === "" || this.companyUser === "" || this.educationUser === "" || this.sexUser === "" || this.nameUser === "") {
                this.infoIsRed1 = 1;
                return;
            }
            this.infoIsRed1 = 0;
            this.axios
                .get("/accessapi/enterprise/cert/getUserEnterpriseCertInfo", {
                    headers: { Authorization: "Bearer " + this.getKey() },
                })
                .then((res) => {
                    const body = res.data;
                    const data = (body && (body.data !== undefined ? body.data : body)) || {};
                    this.enterpriseCertInfoId = data.id != null ? data.id : (data.certId != null ? data.certId : null);
                    this.authLetterCompanyName = (data.companyName != null ? data.companyName : "").toString().trim();
                    this.authLetterCreditCode = (data.creditCode != null ? data.creditCode : "").toString().trim();
                    this.authorizationLetterRejectReason = (data.authorizationLetterRejectReason  || data.rejectReason  || data.refuseReason  || data.authorizationRefuseReason  ||  "").toString().trim();
                    this.clearAuthFile();
                    this.clearAuthLetterTip();
                    const mode = this.mapAuthorizationLetterView(data.authorizationLetterStatus);
                    if (mode === "proceed") {
                        this.proceedToStandardOrder();
                        return;
                    }
                    this.authLetterModalMode = mode;
                    this.authLetterModalVisible = true;
                })
                .catch(() => {
                    this.$message.error("获取企业认证信息失败");
                });
        },
        showAuthLetterTip(msg, type) {
            this.authLetterTopTip = msg || "";
            this.authLetterTopTipType = type === "success" ? "success" : "error";
        },
        clearAuthLetterTip() {
            this.authLetterTopTip = "";
        },
        closeAuthLetterModal() {
            this.authLetterModalVisible = false;
            this.clearAuthFile();
            this.clearAuthLetterTip();
        },
        openAuthFilePicker() {
            if (this.$refs.authFileInput) {
                this.$refs.authFileInput.value = "";
                this.$refs.authFileInput.click();
            }
        },
        triggerAuthFileInput() {
            this.openAuthFilePicker();
        },
        onAuthDragOver() {
            this.authLetterDragOver = true;
        },
        onAuthDragLeave() {
            this.authLetterDragOver = false;
        },
        onAuthFileDrop(e) {
            this.authLetterDragOver = false;
            const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
            this.applyAuthPickedFile(f);
        },
        onAuthFileChange(e) {
            const f = e.target && e.target.files && e.target.files[0];
            this.applyAuthPickedFile(f);
        },
        applyAuthPickedFile(file) {
            if (!file) return;
            this.authLetterPendingFile = file;
            this.authLetterPendingName = file.name;
        },
        clearAuthFile() {
            this.authLetterPendingFile = null;
            this.authLetterPendingName = "";
            if (this.$refs.authFileInput) {
                this.$refs.authFileInput.value = "";
            }
        },
        isAuthFileValidType(file) {
            if (!file || !file.name) return false;
            const n = file.name.toLowerCase();
            return n.endsWith(".pdf")  ||  n.endsWith(".jpg")  ||  n.endsWith(".jpeg")  ||  n.endsWith(".png");
        },
        validateAuthFileForUpload() {
            const f = this.authLetterPendingFile;
            if (!f) {
                this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                return false;
            }
            const maxBytes = 20 * 1024 * 1024;
            if (f.size > maxBytes) {
                this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                return false;
            }
            if (!this.isAuthFileValidType(f)) {
                this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                return false;
            }
            return true;
        },
        downloadAuthLetterTemplate() {
            if (this.authLetterTemplateLoading) {
                return;
            }
            const name = (this.authLetterCompanyName || "").trim();
            const code = (this.authLetterCreditCode || "").trim();
            if (!name || !code) {
                this.showAuthLetterTip("企业名称或统一社会信用代码缺失，请刷新页面后重试", "error");
                return;
            }
            this.authLetterTemplateLoading = true;
            this.clearAuthLetterTip();
            const fd = new FormData();
            fd.append("companyName", name);
            fd.append("creditCode", code);
            this.axios
                .post("/accessapi/enterprise/cert/getAuthorizationLetter", fd, {
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    const body = res.data || {};
                    if (body.status === 200 && body.data) {
                        const url = typeof body.data === "string" ? body.data : (body.data.url || body.data);
                        if (url) {
                            window.open(url, "_blank");
                        } else {
                            this.showAuthLetterTip("未获取到模板地址", "error");
                        }
                    } else {
                        this.showAuthLetterTip(
                            (body.message && String(body.message)) || "获取模板失败，请稍后重试",
                            "error"
                        );
                    }
                })
                .catch(() => {
                    this.showAuthLetterTip("获取模板失败，请稍后重试", "error");
                })
                .finally(() => {
                    this.authLetterTemplateLoading = false;
                });
        },
        postAuthorizationLetter() {
            if (!this.enterpriseCertInfoId) {
                this.showAuthLetterTip("企业认证信息不完整，请刷新页面后重试", "error");
                return;
            }
            if (!this.validateAuthFileForUpload()) return;
            this.clearAuthLetterTip();
            const fd = new FormData();
            fd.append("id", this.enterpriseCertInfoId);
            fd.append("authorizationLetter", this.authLetterPendingFile);
            this.authLetterUploading = true;
            this.axios
                .post("/accessapi/enterprise/cert/uploadAuthorizationLetter", fd, {
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    const d = res.data || {};
                    if (d.status != null && d.status !== 200) {
                        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                        return;
                    }
                    if (d.code != null && d.code !== 200 && d.code !== 0) {
                        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                        return;
                    }
                    if (d.success === false) {
                        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                        return;
                    }
                    this.showAuthLetterTip("上传成功，预计在1-3个工作日内完成审核", "success");
                    this.clearAuthFile();
                    this.authLetterModalMode = "pending";
                })
                .catch(() => {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                })
                .finally(() => {
                    this.authLetterUploading = false;
                });
        },
        confirmAuthLetterAction() {
            if (this.authLetterUploading) return;
            this.postAuthorizationLetter();
        },
        //获取标准版价格
        getStandardPrice(){
          this.axios.get("/tilesapi/tiles/standard/price/standardTilesPrice",
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
            params: {
              standard: this.standardParam.productType,
              map: this.standardParam.yearVersion,
            },
          }
          ).then((res) => {
            console.log(res)
            res.data.data&&(this.standardPrice=res.data.data.price);
            res.data.data&&(this.ifPurchased=res.data.data.purchaseResult)
          })

        },
        //带权限判断的跳转
        jumpWithPermission(type, path, fromUrl,event) {
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId = localStorage.getItem("userId"); //是否已登录
            let authentication = localStorage.getItem("authentication"); //0:已实名；1：未实名
            if (type == "可游客") {
                if (fromUrl) {
                    window.open(
                        rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                        "_self"
                    );
                } else {
                    window.open(rootUrl + path, "_self");
                }
            } else if (type == "仅登录") {
                //已登录
                if (loginUserId) {
                    if (fromUrl) {
                        window.open(
                            rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                            "_self"
                        );
                    } else {
                        window.open(rootUrl + path, "_self");
                    }
                }
                //未登录
                else {
                    if (fromUrl) {
                        window.open(
                            rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                            "_self"
                        );
                    } else {
                        window.open(rootUrl + "/Login", "_self");
                    }
                }
            } else if (type == "仅实名") {
                //已登录
                if (loginUserId) {
                    //已实名
                    if (authentication == "0") {
                        if (fromUrl) {
                        window.open(
                            rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                            "_self"
                        );
                        } else {
                            window.open(rootUrl + path, "_self");
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl + "/Authentication", "_self");
                    }
                }
                //未登录
                else {
                    if (fromUrl) {
                        window.open(
                            rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                            "_self"
                        );
                    } else {
                        window.open(rootUrl + "/Login", "_self");
                    }
                }
            }
        },
        //实名权限检查与处理（遥感商城版）
        checkAndHandleAuthentication(){
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            if(localStorage.getItem('preRoute')=="/Login"){
              this.$router.push('/');
            }else {
              setTimeout(()=>{
                this.$router.push('/Login');
              },100)
            }
            return false;
          }
          else if(authentication!='0'){
            if(localStorage.getItem('preRoute')=="/Authentication"){
              setTimeout(()=>{
                this.$router.push('/');
              },100)
            }
            else {
              return false;
            }
          }
          return true;
        },
        getKey() {
            return localStorage.getItem("token");
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        blueCartoon(){
            gsap.from('.tip',{duration:1, height:"0px"})
            gsap.to('.tip',{duration:1,delay:1, background:"#F5F5F6",color:"#3a3a3a"})
        },
        getHeight(i){
            let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            let h = windowHeight - 272
            let whiteId = document.getElementById("whiteId")
            let whiteHeight = 879
            if(i==1 || i==7){
                whiteHeight=1185
            }else if(i==2){
                whiteHeight=879
            }else if(i==3){
                whiteHeight=2429
            }else if(i==4){
                whiteHeight=2235
            }else if(i==5){
                whiteHeight=2429
            }else if(i==6){
                whiteHeight=735
            }else if(i==8 || i==9 || i==10){
                whiteHeight=1379
            }
            if(h>whiteHeight){
                whiteId.style.height= h +"px"
            }
        },
        invoiceSelect(i){
            this.invoice=i
            this.invoiceMessage()
        },
        //发票信息带入
        invoiceMessage(){
            this.axios
                    .post(
                        "/loginapi/invoice/queryUserDefaultInvoiceInfo",null,
                        {headers: {
                                Authorization: this.getKey(),
                            },}
                    )
                    .then((res) => {
                        let data = res.data.data
                        if(data!=''&&data!=null){
                            if(data.category==0){
                                this.qyCompany=data.company
                                this.qyNumber=data.identifyNumber
                            }else if(data.category==1){
                                this.zpCompany=data.company
                                this.zpNumber=data.identifyNumber
                                this.address=data.companyAddress
                                this.bank=data.bankName
                                this.phone=data.companyPhone
                                this.bankNumber=data.bankNumber

                            }
                        }
                    });
        },
        //用户信息回显
        getUserData(){
            this.axios.post("/tilesapi/queryUserInfo",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                let data = res.data.data
                console.log(data);
                if(data.name!=''&& data.name!=null){
                    this.nameUser=data.name
                }
                this.sexUser=data.sex

                if(data.age!=''&& data.age!=null){
                    this.ageUser=data.age
                }
                if(data.education!=''&& data.education!=null){
                    this.educationUser=data.education
                }
                if(data.company!=''&& data.company!=null){
                    this.companyUser=data.company
                }

            })
        },
        //根据传递的参数展示相应页面
        //参数说明
        // block1Status： 1 未申请体验版和标准版  2 申请体验版未申请标准版  3 申请标准版体验版都可以
        // selectBasis 0 体验版未选中  1体验版选中  2 体验版不可选
        // selectEnterprise  0标准版未选中 1标准版选中
        // selectBusiness 0区县图未选中 1区县图选中 //区县就是专业版
        // baseInfo  0不提交信息 1提交体验版信息 2提交标准版信息 3提交区县图信息
        show(){
            let processType = this.$route.query.processType;
            this.processType=processType
            this.getHeight(processType)
            if(processType==1){
                this.block1Status=1
                this.selectBasis=1
                this.selectEnterprise=0
                this.selectBusiness=0
                this.baseInfo=1
            }else if(processType==2){
                this.block1Status=2
                this.selectBasis=2
                this.selectEnterprise=0
                this.selectBusiness=0
                this.baseInfo=0
            }else if(processType==3){
                this.block1Status=2
                this.selectBasis=2
                this.selectEnterprise=1
                this.selectBusiness=0
                this.baseInfo=2
            }else if(processType==4){
                this.block1Status=1
                this.selectBasis=0
                this.selectEnterprise=1
                this.selectBusiness=0
                this.baseInfo=2
            }else if(processType==5){
                this.block1Status=3
                this.selectBasis=2
                this.selectEnterprise=1
                this.selectBusiness=0
                this.baseInfo=2
            }else if(processType==6){
                this.block1Status=3
                this.selectBasis=1
                this.selectEnterprise=0
                this.selectBusiness=0
                this.baseInfo=1
            }else if(processType==7){
                this.block1Status=1
                this.selectBasis=0
                this.selectEnterprise=0
                this.selectBusiness=1
                this.baseInfo=3
            }else if(processType==8){
                this.block1Status=2
                this.selectBasis=2
                this.selectEnterprise=0
                this.selectBusiness=1
                this.baseInfo=3
            }else if(processType==9){
                this.block1Status=3
                this.selectBasis=2
                this.selectEnterprise=0
                this.selectBusiness=1
                this.baseInfo=3
            }else if(processType==10){
                this.block1Status=3
                this.selectBasis=0
                this.selectEnterprise=0
                this.selectBusiness=1
                this.baseInfo=3
            }
            //标准版
            else if(processType==11){
              this.baseInfo=2
              if(this.selectBasis!=2){
                this.selectBasis=0
              }else{
                this.selectBasis=2
              }
              this.standardPrice='';
              this.standardParam.productType='A';
              this.standardParam.yearVersion='2024年全国高质量一张图',
                  this.getStandardPrice();
              this.selectEnterprise=1;
              this.selectBusiness=0
              this.getHeight(4)
            }

        },
        selectVersion(i){
            this.baseInfo=i
            if(i==1){
                this.selectBasis=1
                this.selectEnterprise=0;
                this.selectBusiness=0
                this.getHeight(1)
            }else if(i==2){
                if(this.selectBasis!=2){
                    this.selectBasis=0
                }else{
                    this.selectBasis=2
                }
                this.standardPrice='';
                this.standardParam.productType='A';
                this.standardParam.yearVersion='2024年全国高质量一张图',
                this.getStandardPrice();
                this.selectEnterprise=1;
                this.selectBusiness=0
                this.getHeight(4)
            }else if(i==3){
                if(this.selectBasis!=2){
                    this.selectBasis=0
                }else{
                    this.selectBasis=2
                }
                this.selectEnterprise=0;
                this.selectBusiness=1
                if(this.block1Status==1){
                    this.getHeight(7)
                }else if(this.block1Status==2||this.block1Status==3){
                    this.getHeight(8)
                }
            }
        },
        //申请体验版
        applyBasis(){
            let url = "/Purchase"
            if(this.$store.state.user.logined){
                this.applyBasis1()
            }else{
                this.axios.get("/loginapi/getLoginInfo", {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res) => {
                    if(res.data.success){
                        this.$store.state.user.logined = true;
                        this.applyBasis1()
                    }else{
                        this.$router.push({path: "/Login",query: {'returnUrl':url,'version':1}});
                    }
                })
            }

        },
        applyBasis1(){
            let canApply1=false
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''){
                this.infoIsRed1=1
                canApply1=false
            }else{
                canApply1=true
                this.infoIsRed1=0
            }

            this.timer2 = setInterval(()=>{
                    this.info2IsEmpty()
                },1000)

            var userInfo = {
                age: this.ageUser,
                company: this.companyUser,
                education: this.educationUser,
                sex: this.sexUser

            };
            let canApply2=false
            if(this.xieyi==false){
                canApply2=false
                this.infoIsRed3=1

            }else{
                canApply2=true
                this.infoIsRed3=0

            }
            if(canApply1&&canApply2){
                this.axios.post("/tilesapi/tiles/register/addTrialTileOrder",userInfo, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    clearInterval(this.timer2);
                    let data = res.data
                    if(data.msg=='需要实名认证注册后才能申请套件!'){
                        this.$router.push({path:"/Authentication?returnUrl=" + '/Purchase'})
                    }else{
                        if(data.code==200){
                            this.$router.push({path: "/MyRSservice"});
                        }else{
                            alert("申请失败！请重新申请或者联系商务经理咨询")
                        }
                    }
                })
            }
        },
        //申请标准版
        applyEnterprise(){
            if(!this.xieyi){
              this.infoIsRed3=true;
              return;
            }
            let url = "/Purchase"
            if(this.$store.state.user.logined&&localStorage.getItem('authentication')=='0'){
                this.axios.get("/loginapi/getUserForUserCenter",{
                    headers: {
                        Authorization: "Bearer " + this.getKey(),}
                    }).then((res) => {
                    if(res.status==200){
                        const d = res.data && res.data.data;
                        if (!d) {
                            alert("系统错误");
                            return;
                        }
                        const certificationIdentity = String(d.certificationIdentity);
                        if (certificationIdentity === "2" || certificationIdentity === "3") {
                            this.proceedToStandardOrder();
                            return;
                        }
                        const ecRaw = d.enterpriseCertStatus;
                        const ecStr = ecRaw === null || ecRaw === undefined || ecRaw === "" ? "" : String(ecRaw).trim();
                        if (ecStr === "" || ecStr === "null") {
                            this.shadowTip = true;
                            return;
                        }
                        if (ecStr === "1") {
                            this.jumpWithPermission("仅实名", "/store/VIPBenefits", "/rskit/Purchase");
                            return;
                        }
                        if (ecStr === "0" || ecStr === "2" || ecStr === "3") {
                            this.loadEnterpriseCertInfoForLetterModal();
                        } else {
                            this.shadowTip = true;
                        }
                    }
                    else {
                        alert('系统错误')
                    }
                })
            }else if(this.$store.state.user.logined){
              this.$router.push({path:"/Authentication?returnUrl=" + '/Purchase'})
            }
            else{
                this.axios.get("/loginapi/getLoginInfo", {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res) => {
                    if(res.data.success){
                        this.$store.state.user.logined = true;
                    }else{
                        this.$router.push({path: "/Login",query: {'returnUrl':url,'version':2}});
                    }
                })
            }
        },
        applyEnterprise1(){
            let canApply1=false
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''||this.ageUser==null||this.companyUser==null||this.educationUser==null||this.sexUser==null||this.nameUser==null){
                this.infoIsRed1=1
                canApply1=false
            }else{
                canApply1=true
                this.infoIsRed1=0
            }
            let canApply4=false
            if(this.xieyi==false){
                canApply4=false
                this.infoIsRed3=1

            }else{
                canApply4=true
                this.infoIsRed3=0

            }
            let repositoryId=""
            let redemptionCodePrefix=''
            if(this.priceSelect==1){
                repositoryId="a6f6a097-cf83-44cb-93d4-a1430313"
                redemptionCodePrefix='JLTK23WY'
            }else if(this.priceSelect==2){
                repositoryId="0ac78679-bea3-4c10-a7c4-e6155ca2"
                redemptionCodePrefix='JLTK23Q1'
            }else if(this.priceSelect==3){
                repositoryId="025efa2f-dede-43d0-9e92-14ef3dde"
                redemptionCodePrefix='JLTK23Q2'
            }else if(this.priceSelect==4){
                repositoryId="007540c3-f0a1-4816-88be-785a6882"
                redemptionCodePrefix='JLTK23Q3'
            }else if(this.priceSelect==5){
                repositoryId="64ac6ffe-dbd4-4b9c-a5f2-4041dc97"
                redemptionCodePrefix='JLTK23Q4'
            }else if(this.priceSelect==6){
                repositoryId="0598c86a-6a23-4409-a10f-904357a5"
                redemptionCodePrefix='JLTK24WY'
            }else if(this.priceSelect==7){
                repositoryId="4936d426-9c14-5caf-245e-e1644427"
                redemptionCodePrefix='JLTK24Q1'
            }else if(this.priceSelect==8){
                repositoryId="831e893e-6860-486c-960b-a27db6ccf94e"
                redemptionCodePrefix='JLTK24Q2'
            }else if(this.priceSelect==9){
                repositoryId="dab9b1c9-b2f4-41fc-8317-53ef9a2e031f"
                redemptionCodePrefix='JLTK24Q3'
            }
            if(this.purchaseMode===1){
                let canApply2=false
                let canApply3=false

                if(this.contractUser==''){
                    this.infoIsRed2=1
                    canApply2=false

                }else{
                    this.infoIsRed2=0
                    canApply2=true
                }

                this.timer = setInterval(()=>{
                        this.info1IsEmpty()
                    },1000)


                if(this.invoice==1){
                    canApply3=true
                }else if (this.invoice==2){
                    if(this.qyCompany==''||this.qyCompany==null||this.qyNumber==''||this.qyNumber==null){
                        canApply3=false
                        this.infoIsRed2=1
                    }else{
                        canApply3=true
                        this.infoIsRed2=0
                    }
                }else if (this.invoice==3){
                    if(this.zpCompany==''||this.zpCompany==null||this.zpNumber==''||this.zpNumber==null||this.address==''||this.address==null||this.phone==''||this.phone==null||this.bank==''||this.bank==null||this.bankNumber==''||this.bankNumber==null){
                        canApply3=false
                        this.infoIsRed2=1
                    }else{
                        canApply3=true
                        this.infoIsRed2=0
                    }
                }
                let invoiceType = "gr"
                var userInfo={}
                if(this.invoice==1){
                    invoiceType="gr"
                    userInfo = {
                        age: this.ageUser,
                        company: this.companyUser,
                        education: this.educationUser,
                        sex: this.sexUser,
                        repositoryId: repositoryId,
                        userClientName: this.contractUser,
                        invoiceType: invoiceType,
                        invoiceJson:{}
                    };
                }else if(this.invoice==2){
                    invoiceType="qy"
                    userInfo = {
                        age: this.ageUser,
                        company: this.companyUser,
                        education: this.educationUser,
                        sex: this.sexUser,
                        repositoryId: repositoryId,
                        userClientName: this.contractUser,
                        invoiceType: invoiceType,
                        invoiceJson:{
                            number:this.qyNumber,
                            companyName:this.qyCompany
                        }
                    };
                }else if(this.invoice==3){
                    invoiceType="zp"
                    userInfo = {
                        age: this.ageUser,
                        company: this.companyUser,
                        education: this.educationUser,
                        sex: this.sexUser,
                        repositoryId: repositoryId,
                        userClientName: this.contractUser,
                        invoiceType: invoiceType,
                        invoiceJson:{
                            number:this.zpNumber,
                            companyName:this.zpCompany,
                            address:this.address,
                            phone:this.phone,
                            bank:this.bank,
                            bankNumber:this.bankNumber,
                        }
                    };
                }
                if(canApply1&&canApply2&&canApply3&&canApply4){
                    this.axios.post("/tilesapi/tiles/register/addCompanyTileOrder",userInfo, {
                        headers: {
                        Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((res)=>{
                        console.log(res);
                        clearInterval(this.timer);
                        let data = res.data
                        if(data.msg=='需要实名认证注册后才能申请套件!'){
                            this.$router.push({path:"/Authentication?returnUrl=" + '/Purchase'})
                        }else{
                            if(data.code==200){
                                let id = data.data.id
                                this.$router.push({path: "/process",query: {'id':id}});
                            }else{
                                alert("申请失败！请重新申请或者联系商务经理咨询")
                            }
                        }
                    })
                }

            }else if(this.purchaseMode===2){
                let canApply5 = true
                let redemptionCode = this.repInputContent
                if(redemptionCode==''||redemptionCode==null||redemptionCode==undefined){
                    canApply5 = false
                    this.infoIsRed4=1
                }
                let redemptionCodeList = ''
                for(let i=0;i<redemptionCode.length-1;i++){
                    redemptionCodeList=redemptionCode[i].value+redemptionCodeList
                    if(redemptionCode[i].value==undefined||redemptionCode[i].value==null||redemptionCode[i].value==''){
                        canApply5 = false
                        this.infoIsRed4=1
                    }
                }
                redemptionCodeList=redemptionCodePrefix+redemptionCodeList.split("").reverse().join("")
                console.log(redemptionCodeList);
                this.timer = setInterval(()=>{
                        this.info1IsEmpty1()
                    },1000)
                var userInfo1 = {
                        age: this.ageUser,
                        company: this.companyUser,
                        education: this.educationUser,
                        sex: this.sexUser,
                        repositoryId: repositoryId,
                        redemptionCode:redemptionCodeList
                    }
                if(canApply1&&canApply4&&canApply5){
                this.axios.post("/tilesapi/tiles/register/addRedemptionTileOrder",userInfo1, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    clearInterval(this.timer);
                    console.log(res);
                    let data = res.data
                    if(data.code==500){
                        console.log(111);
                        this.infoIsRed5=1
                    }else{
                        let id = data.data.id
                        let createTime = data.data.createTime
                        let redemptionCode = data.data.redemptionCode
                        let agentName = data.data.agentName
                        let repositorySubName = data.data.repositorySubName
                        this.$router.push({path: "/processRep",query: {'id':id,'createTime':createTime,'redemptionCode':redemptionCode,'agentName':agentName,'repositorySubName':repositorySubName}});
                    }
                })
                }
            }

        },
        //申请专业版
        applyCouty(){
            let url = "/Purchase"
            if(this.$store.state.user.logined){
                this.applyCouty1()
            }else{
                this.axios.get("/loginapi/getLoginInfo", {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res) => {
                    if(res.data.success){
                        this.$store.state.user.logined = true;
                        this.applyCouty1()
                    }else{
                        this.$router.push({path: "/Login",query: {'returnUrl':url,'version':2}}); //
                    }
                })
            }
        },
        applyCouty1(){
            let canApply1=false
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''
                ||this.ageUser== null||this.companyUser== null||this.educationUser== null||this.sexUser== null||this.nameUser== null
            ){
                this.infoIsRed1=1
                canApply1=false
            }else{
                canApply1=true
                this.infoIsRed1=0
            }

            this.timer3 = setInterval(()=>{
                    this.info3IsEmpty()
                },1000)
            //换一下接口
            if(canApply1){
                this.$store.state.county.name = this.nameUser;
                this.$store.state.county.company = this.companyUser;
                this.$store.state.county.age = this.ageUser;
                this.$store.state.county.sex = this.sexUser;
                this.$store.state.county.education = this.educationUser;
                this.$router.push('/buyCountyProduction');
            }
        },
        //监控标准版资料是否填写完成
        info1IsEmpty(){
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''||this.ageUser==null||this.companyUser==null||this.educationUser==null||this.sexUser==null||this.nameUser==null){
                this.infoIsRed1=1
            }else{
                this.infoIsRed1=0
            }
            if(this.contractUser==''){
                this.infoIsRed2=1

            }else{
                this.infoIsRed2=0
            }
            if (this.invoice==2){
                if(this.qyCompany==''||this.qyCompany==null||this.qyNumber==''||this.qyNumber==null){
                    this.infoIsRed2=1
                }else{
                    this.infoIsRed2=0
                }
            }else if (this.invoice==3){
                if(this.zpCompany==''||this.zpCompany==null||this.zpNumber==''||this.zpNumber==null||this.address==''||this.address==null||this.phone==''||this.phone==null||this.bank==''||this.bank==null||this.bankNumber==''||this.bankNumber==null){
                    this.infoIsRed2=1
                }else{
                    this.infoIsRed2=0
                }
            }
            if(this.xieyi==false){
                this.infoIsRed3=1
            }else{
                this.infoIsRed3=0

            }
        },
        //监控标准版兑换码资料是否填写完成
        info1IsEmpty1(){
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''||this.ageUser==null||this.companyUser==null||this.educationUser==null||this.sexUser==null||this.nameUser==null){
                this.infoIsRed1=1
            }else{
                this.infoIsRed1=0
            }
            if(this.xieyi==false){
                this.infoIsRed3=1
            }else{
                this.infoIsRed3=0
            }
            let canApply5 = true
            let redemptionCode = this.repInputContent
            for(let i=0;i<redemptionCode.length-1;i++){
                if(redemptionCode[i].value==undefined||redemptionCode[i].value==null||redemptionCode[i].value==''){
                    canApply5 = false
                    this.infoIsRed4=1
                }
            }
            if(canApply5){
                this.infoIsRed4=0
            }
        },
        //监控体验版资料是否填写完成
        info2IsEmpty(){
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''){
                this.infoIsRed1=1
            }else{
                this.infoIsRed1=0
            }
            if(this.xieyi==false){
                this.infoIsRed3=1
            }else{
                this.infoIsRed3=0

            }
        },
        //监控区县版资料是否填写完成
        info3IsEmpty(){
            if(this.ageUser==''||this.companyUser==''||this.educationUser==''||this.sexUser==''||this.nameUser==''){
                this.infoIsRed1=1
            }else{
                this.infoIsRed1=0
            }
        },
        openXieyi(){
            window.open("https://files.jl1mall.com/tiles/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE/%E2%80%9C%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E2%80%9D%E9%81%A5%E6%84%9F%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%94%A8%E6%88%B7%E4%BD%BF%E7%94%A8%E5%8D%8F%E8%AE%AE.pdf")
        },
        
    },
    watch:{
      standardParam:{
        handler:function () {
          this.getStandardPrice();
          console.log(this.standardParam)
        },
        deep:true
      },
    },
    mounted() {
        document.getElementById('barId').scrollIntoView({ behavior: "instant"});
        this.checkAndHandleAuthentication()
        this.show()
        this.toPageTop()
        this.blueCartoon()
        this.getUserData()
    },
    created(){
    }
  };
  </script>

  <style scoped>
  th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
  }
  .standardPriceCtn{
    position: absolute;
    right:0px;
    top:-45px;
    height: 50px;
    width: 300px;
    line-height: 50px;
    text-align: right;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
  }
  .checkBlockCtn{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    position: absolute;
  }
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.tip{
    position: relative;
    width: 100%;
    height: 76px;
    background: #0066CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 76px;
    text-align: center;
}
.white{
    position: relative;
    width: 1280px;
    height: auto;
    margin-left: calc(50% - 640px);
    background-color: #fff;

}
.noBuy{
    position: relative;
    width: 1280px;
    height: 192px;
    margin-top: 75px;
    /* background-color: palegoldenrod; */
}

.baseText1{
    position: absolute;
    top: 0px;
    left: calc(50% - 640px);
    width: 1280px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.baseImg1{
    position: absolute;
    top: 92px;
    left: calc(50% - 13px);
    width: 26px;
    height: 26px;
}
.baseText2{
    position: absolute;
    top: 136px;
    left: calc(50% - 150px);
    width: 300px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.baseText3{
    position: absolute;
    top: 170px;
    left: calc(50% - 640px);
    width: 1280px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1E81EB;
    line-height: 22px;
    text-align: center;
}
.buyBasis{
    position: relative;
    margin-top: 75px;
    width: 1280px;
    height: 386px;
    /* background-color: pink; */
}
.buyEnterprise{
    position: relative;
    margin-top: 75px;
    width: 1280px;
    height: 386px;
    /* background-color: pink; */
}
.block2{
    position: relative;
    width: 1280px;
    height: 150px;
    margin-top: 75px;
}
.selectBlock2{
    position: absolute;
    top: 0;
    left: 0;
    width: 400px;
    height: 150px;
    border-radius: 16px;
    border: 1px solid #979797;
    cursor: pointer;
}
.selectText1{
    position: absolute;
    top: 40px;
    width: 400px;
    left: calc(50% - 200px);
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 33px;
    text-align: center;
}
.selectText2{
    position: absolute;
    top: 87px;
    width: 400px;
    left: calc(50% - 200px);
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
    text-align: center;
}
.block3Basis{
    position: relative;
    margin-top: 93px;
    width: 1280px;
    min-height:600px;
    height: auto;
    overflow: hidden;
    /* background-color: pink; */
}
.block3BasisContent{
    position: relative;
    margin-top: 0px;
    width: 1280px;
    /* height: 1150px; */
    height: 1340px;
    overflow: hidden;
}
.block3Img{
    position: absolute;
    top: 0;
    left: 0;
    width: 179px;
    height: 51px;
}
.block3Text1{
    position: absolute;
    top: 40px;
    left: 22px;
    width: 200px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
}
.block3Line{
    position: absolute;
    top: 23px;
    left: 215px;
    width: 1065px;
    height: 1px;
    border-bottom: 1px dashed rgba(0,0,0,0.3);
}
.block3Select{
    position: absolute;
    top: 488px;
    left: 0px;
    width: 262px;
    height: 54px;
    background: #FFFFFF;
    border-radius: 27px;
    border: 1px solid #0066CC;
}
.block3SelectRun{
    position: absolute;
    top: 5px;
    left: 5px;
    width: 128px;
    height: 44px;
    background: #0066CC;
    border-radius: 22px;
    transition: 0.3s;
}
.block3SelectText1{
    position: absolute;
    top: 16px;
    left: 37px;
    width: 70px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 22px;
}
.block3SelectText1-s{
    position: absolute;
    top: 16px;
    left: 37px;
    width: 70px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    cursor: pointer;
}
.infoRed{
    position: absolute;
    top: 2px;
    width: 550px;
    left: 365px;
    height: 40px;
    background: #FF4040;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    z-index: 1;
}
.block3Name{
    position: absolute;
    top: 171px;
    left: 0;
    width: 390px;
    height: 54px;
    border-radius: 8px;
}
.block3Img1{
    position: absolute;
    left: 0;
    top: 385px;
    cursor: pointer;
}
.block3Text2{
    position: absolute;
    left: 0;
    top: 445px;
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight:600;
    color: #000000;
    line-height: 22px;
}
.block3Button{
    position: absolute;
    top: 447px;
    right: 0;
    width: 200px;
    height: 54px;
    background: #1E81EB;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 54px;
    text-align: center;
    cursor: pointer;

}
.block3Button1{
    position: relative;
    margin-top: 447px;
    margin-left: 1080px;
    margin-bottom: 200px;
    width: 200px;
    height: 54px;
    background: #1E81EB;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 54px;
    text-align: center;
    cursor: pointer;

}
/* .priceFour{
    position: absolute;
    top: 582px;
    width: 1280px;
    height: 72px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.priceFour-s{
    position: absolute;
    top: 582px;
    width: 1280px;
    height: 72px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 2px solid #1E81EB;
} */
.priceFour{
    position: relative;
    margin-top: 582px;
    width: 1280px;
    height: 72px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.priceFour-s{
    position: relative;
    margin-top: 582px;
    width: 1280px;
    height: 72px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 2px solid #1E81EB;
}
.priceText1{
    position: absolute;
    top: 22px;
    left: 72px;
    width: 200px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 28px;
}
.priceLine{
  position: absolute;
  top: 24px;
  left: 278px;
  width: 1px;
    height: 24px;
    background-color:#979797;
}
.priceLine-s{
  position: absolute;
  top: 24px;
  left: 278px;
  width: 1px;
    height: 24px;
    background-color:  #1E81EB;
}
.priceImg1{
    position: absolute;
    top: 28px;
    left: 328px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.priceText2{
    position: absolute;
    top: 25px;
    left: 354px;
    width: 120px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
}
.priceText3{
    position: absolute;
    top: 22px;
    left: 1115px;
    width: 200px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 28px;
}
.blockText2{
    position: relative;
    margin-top: 30px;
    padding-left: 26px;
    width: 1280px;
    height: 44px;
    background: #F5F5F6;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 44px;
}
.redemptionCode{
    position: absolute;
    top: 1080px;
    width: 1280px;
    height: 72px;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.25);
}
.repText1{
    position: absolute;
    top: -8px;
    left: 23px;
    width: 130px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #979797;
    line-height: 17px;
    background-color: #fff;
    padding-left: 5px;
}
.repNumber{
    position: absolute;
    top: 19px;
    left: 22px;
    width: 30px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #979797;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #979797;
    line-height: 36px;
    text-align: center;
}
.repInputBlock{
    position: absolute;
    width: 350px;
    height: 36px;
    left: 328px;
    top: 19px;
    /* background-color: pink; */
}
.repInput{
    float: left;
    width: 30px;
    height: 36px;
    margin-right: 8px;
    margin-top: 0;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #979797;
    line-height: 36px;
    border: none;
    outline: none;
    text-align: center;
}
.repInput-s{
    float: left;
    width: 30px;
    height: 36px;
    margin-right: 8px;
    margin-top: 0;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 36px;
    border: none;
    outline: none;
    text-align: center;
}
.block3Text3{
   margin-top: 50px;
    padding-left: 26px;
    padding-right: 26px;
    padding-top: 23px;
    width: 1280px;
    height:110px;
    background: #F5F5F6;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 24px;
}
.block3Text5{
    position: absolute;
    top: 0;
    left: 30px;
    width: 800px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight:400;
    color: #000000;
    line-height: 22px;
}
.block3Tex6{
    position: relative;
    margin-top: 80px;
    width: 800px;
height: 22px;
}
.block3Text4{
    position: absolute;
    top: 0;
    width: 1280px;
    height: 92px;
    background: #F5F5F6;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 92px;
    text-align: center;
}
.invoice{
    position:relative;
    width: 1280px;
    height: auto;
    margin-top: 0px;
    margin-left: calc(50% - 640px);
    /* background-color: pink; */
    overflow: hidden;
}
.greyText1{
    position: absolute;
    top: 40px;
    left: 0;
    width: 100px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
}
.greyIcon{
    position: absolute;
    width: 16px;
    height: 16px;
    top: 42px;
    left: 180px;
    cursor: pointer;
}
.greyText3{
    position: absolute;
    top: 40px;
    left: 213px;
    width: 210px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
}
.greyText4{
    position: absolute;
    top: 65px;
    left: 214px;
    width:40px;
height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 17px;
}
.greyInvoice{
    position: relative;
    margin-top: 13px;
    margin-left: 52px;
    width: 1175px;
    height: 1px;
    /* background-color: plum; */
    overflow: hidden;
}
.greyInvoice1{
    position: relative;
    margin-top: 13px;
    margin-left: 52px;
    width: 1175px;
    height: 100px;
    /* background-color: plum; */
    overflow: hidden;
}
.greyInvoice2{
    position: relative;
    margin-top: 13px;
    margin-left: 52px;
    width: 1175px;
    height: 400px;
    /* background-color: plum; */
    overflow: hidden;
}
.qyInvoice{
    position: absolute;
    left: -100px;
    width: 1175px;
    height: 100px;
}
.qyText1{
    position: absolute;
    top: 10px;
    left: 240px;
    width: 200px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: right;
}
.greyInput{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.inputContent{
  position: absolute;
  top: 5px;
    left: 5px;
  width: 370px;
height: 30px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3a3a3a;
line-height: 30px;
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.zpInvoice{
    position: absolute;
    top: 0;
    left: -100px;
    width: 1175px;
    height: 400px;
}
.zpLine{
    position: absolute;
    top: 130px;
    left: 325px;
    width: 500px;
    height: 1px;
    border-bottom: 1px #979797 dashed;
}
.zpText1{
    position: absolute;
    top: 121px;
    left: 530px;
    width: 80px;
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #A8A8A8;
    line-height: 20px;
    text-align: center;
    background-color: #fff;
}
.blockLine3-s{
    margin-top: 10px;
    width: 1280px;
    height: 1px;
    border-bottom: 1px dashed rgba(0,0,0,0.3);
}
.block3Text2-s{
    margin-top: 30px;
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight:600;
    color: #000000;
    line-height: 22px;
}

  </style>
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
.authLetterLayer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000002;
    pointer-events: auto;
}
.authLetterTopTip {
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    z-index: 2;
    text-align: center;
    box-sizing: border-box;
    pointer-events: none;
}
.authLetterTopTipInner {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    max-width: 90%;
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    pointer-events: auto;
    text-align: left;
}
.authLetterTopTipInner--success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipInner--error {
    background: #fff2f0;
    border: 1px solid #ffccc7;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipText {
    line-height: 1.4;
    word-break: break-word;
}
.authLetterTopTipMark {
    flex-shrink: 0;
    font-weight: 700;
    line-height: 1.2;
}
.authLetterTopTipInner--success .authLetterTopTipMark {
    color: #52c41a;
}
.authLetterTopTipInner--error .authLetterTopTipMark {
    color: #ff4d4f;
}
.authLetterShadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
}
.authLetterModal {
    position: relative;
    width: 600px;
    max-width: 100%;
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    padding: 28px 32px 32px;
    box-sizing: border-box;
}
.authLetterClose {
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.authLetterTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.88);
    margin-bottom: 16px;
    padding-right: 32px;
}
.authLetterDesc {
    text-align: center;
    font-size: 15px;
    line-height: 1.6;
    color: rgba(0,0,0,0.65);
    margin-bottom: 20px;
}
.authLetterReject {
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,0.45);
    margin-bottom: 20px;
}
.authLetterDrop {
    border: 1px dashed #c9cdd4;
    background: #fafafa;
    border-radius: 8px;
    padding: 32px 16px 28px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 12px;
    transition: background 0.2s, border-color 0.2s;
}
.authLetterDrop--active {
    background: #f0f7ff;
    border-color: #1E81EB;
}
.authLetterFileInput {
    display: none;
}
.authLetterDropIcon {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}
.authLetterDropLine1 {
    font-size: 15px;
    color: rgba(0,0,0,0.88);
    margin-bottom: 8px;
}
.authLetterDropLine2 {
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.authLetterFileRow {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    margin-bottom: 4px;
    padding: 0 4px;
}
.authLetterFileClip {
    margin-right: 6px;
    font-size: 14px;
}
.authLetterFileName {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.authLetterFileRemove {
    margin-left: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #999;
}
.authLetterFileRemove:hover {
    color: #333;
}
.authLetterBar {
    height: 2px;
    background: #1E81EB;
    border-radius: 1px;
    margin: 0 0 12px 0;
}
.authLetterLink {
    display: block;
    text-align: center;
    color: #1E81EB;
    font-size: 15px;
    margin-bottom: 24px;
    cursor: pointer;
    text-decoration: none;
}
.authLetterLink:hover {
    text-decoration: underline;
}
.authLetterLink--disabled {
    color: #bfbfbf !important;
    cursor: not-allowed;
    pointer-events: none;
}
.authLetterBtns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px;
}
.authLetterBtn1 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #1E81EB;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
    border: none;
}
.authLetterBtn1--disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
.authLetterBtn2 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.45);
    font-size: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
}
</style>
